import 'reset-css';
import App from './App';
import './css/index.scss';
import React from 'react';
import './assets/fonts/fonts.css';
import {Provider} from 'react-redux';
import ReactDOM from 'react-dom/client';
import {persistor, store} from './store/index';
import {PersistGate} from 'redux-persist/integration/react';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ConfigProvider } from 'antd';
import { register } from './serviceWorkerRegistration';

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [rtlPlugin],
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <CacheProvider value={cacheRtl}>
    <ConfigProvider direction="rtl">
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    </ConfigProvider>
    </CacheProvider>
  </React.StrictMode>,
);

// فعال‌سازی سرویس‌ورکر
register();
